import { Routes, Route, Navigate } from "react-router-dom";

import DomesticExpress from "./DomesticExpress";

const domesticExpressRoutes = [
  { routeName: "overnight", component: <DomesticExpress /> },
  { routeName: "samedaydelivery", component: <DomesticExpress /> },
  { routeName: "2nddaydelivery", component: <DomesticExpress /> },
  { routeName: "timechoicedelivery", component: <DomesticExpress /> },
  { routeName: "redbox", component: <DomesticExpress /> },
  { routeName: "economyexpress", component: <DomesticExpress /> },
  { routeName: "expressflyer", component: <DomesticExpress /> },
  { routeName: "mehfoozexpress", component: <DomesticExpress /> },
  { routeName: "liquidshipping", component: <DomesticExpress /> },
  { routeName: "studentexpress", component: <DomesticExpress /> },
  { routeName: "attestationservices", component: <DomesticExpress /> },
  { routeName: "ticketingservices", component: <DomesticExpress /> },
  { routeName: "retail_cod", component: <DomesticExpress /> },
  { routeName: "paymentsolution", component: <DomesticExpress /> },
  { routeName: "shipmentinsurance", component: <DomesticExpress /> },
  { routeName: "tcsfresh", component: <DomesticExpress /> },
  { routeName: "ecomsolution", component: <DomesticExpress /> },
  { routeName: "mms", component: <DomesticExpress /> },
  { routeName: "overlandexpress", component: <DomesticExpress /> },
  { routeName: "Warehousing", component: <DomesticExpress /> },
  { routeName: "distribution", component: <DomesticExpress /> },
  { routeName: "pack-n-go", component: <DomesticExpress /> },
  { routeName: "coldchain", component: <DomesticExpress /> },
];

const DomesticExpressRoutes = () => {
  return (
    <Routes>
      {domesticExpressRoutes.map((route, key) => (
        <Route
          key={key}
          path={route.routeName}
          element={route.component}
        ></Route>
      ))}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default DomesticExpressRoutes;
